























































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import {
  register,
  getVisitor,
  updateVisitor,
  checkInformationExists,

  registrationTypeList,
  registrationTypeDisplay,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const PageColumnWithVisitorEditor = defineComponent({
  components: {
    CommonModalWithPreset,
  },
  props: {
    edit: {
      default() { return false; },
    },
  },
  setup(props: any) {
    const { route } = useRouter();

    const successModal = ref(null);
    const errorModal = ref(null);
    const loading = ref(true);

    const oldInformation = reactive({
      email: '',
      telephone: '',
    });

    const form = reactive({
      name: '',
      email: '',
      telephone: '',
      organization: '',
      registrationType: 'INDIVIDUAL',
      otherRegisterType: '',
      online: 'true',
      // missing backend field
      payment: 'true',
      pin: '',
      call: async () => {
        let response = null;
        /* eslint-disable */
        if (props.edit === true) {
          response = await updateVisitor(
            route.value.params.id,
            form.name,
            form.email,
            form.telephone,
            form.organization,
            form.registrationType,
            form.pin,
            form.payment == 'true' ? true : false,
            form.online == 'true' ? true : false,
            form.otherRegisterType,
            // Missing field
            // (this as any).form.isPress == '1' ? true : false,
          );
        }
        else {
          response = await register(
            form.name,
            form.email,
            form.telephone,
            form.organization,
            true,
            form.online == 'true' ? true : false,
            form.registrationType,
            form.pin,
            form.payment == 'true' ? true : false,
            form.otherRegisterType,
          );
        }
        if (response?.status === 422) (errorModal.value as any).compose({ body: 'PIN นี้ถูกใช้งานในระบบแล้ว' });
        else (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
        /* eslint-enable */
      },
      state: {
        value: 'READY',
      },
    });

    onMounted(async () => {
      if (props.edit === true) {
        const result = (await getVisitor(route.value.params.id)).data;
        form.name = result.user.name;
        form.email = result.user.email;
        form.telephone = result.user.telephone;
        form.organization = result.user.organization;
        form.registrationType = result.user.registration_type;
        form.otherRegisterType = result.user.other_register_type;
        form.online = result.user.online ? 'true' : 'false';
        form.payment = result.user.payment_status ? 'true' : 'false';
        form.pin = result.user.pin;

        oldInformation.email = result.user.email;
        oldInformation.telephone = result.user.telephone;
      } else loading.value = false;
    });

    const telephoneValidationRules = reactive({
      required: true,
      regex: /^((\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}|(\+(\d{11})))$/,
      excluded: [],
    });
    const failedValidatedEmailRule = ref('');
    const checkInformationHandler = _.debounce(async () => {
      const result = await checkInformationExists(
        form.email,
        form.telephone,
      );

      if (result.telephone === true && ((props.edit && oldInformation.telephone !== form.telephone) || !props.edit)) (telephoneValidationRules.excluded as any).push(form.telephone);
      else (telephoneValidationRules.excluded as any) = [];

      if (result.email && ((props.edit && oldInformation.email !== form.email) || !props.edit)) failedValidatedEmailRule.value = `excluded:${form.email}`;
      else failedValidatedEmailRule.value = '';
    }, 500);

    return {
      form,
      telephoneValidationRules,
      failedValidatedEmailRule,
      checkInformationHandler,
      successModal,
      errorModal,

      registrationTypeList,
      registrationTypeDisplay,
    };
  },
});

export default PageColumnWithVisitorEditor;
